import { Type } from 'class-transformer';

// Model imports
import { AccDocumentAttachmentParameterDto } from './acc-document-attachment-parameter-dto';

export class AccAddDocumentsParameterDto {
    communityId: number;
    customerId: string;
    accItemId: number;

    @Type(() => AccDocumentAttachmentParameterDto)
    attachments: AccDocumentAttachmentParameterDto[];
}
